export interface ErrorResponse {
  message?: string;
  errorMessage?: string;
}

export class ApiError extends Error {
  status: number;

  details?: ErrorResponse;

  constructor(message: string, status: number, details?: ErrorResponse) {
    super(message);
    this.name = 'AbortError';
    this.status = status;
    this.details = details;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export const withTimeout = <T>(
  fetchFn: (signal: AbortSignal) => Promise<T>,
  ms: number
): Promise<T> => {
  const controller = new AbortController();

  const timeout = setTimeout(() => {
    controller.abort();
  }, ms);

  return fetchFn(controller.signal)
    .finally(() => clearTimeout(timeout))
    .catch((err: ApiError) => {
      if (err.name === 'AbortError') {
        throw new ApiError('Request timed out', 408, {
          message: `Request timed out`,
        });
      }

      throw err;
    });
};
